import React, { useState, useEffect } from 'react';
import ScheduleEventsTemplate from './scheduleEventsTemplate';
import styles from '../../devotee.module.scss';
import Calendar from './calenderComponent';
import toast from 'react-hot-toast';
import { apiRequest, catchErrorMessageHandler, formatWeekday } from '../../../../infrastructure/backendService';
import ToastError from '../../../common/toast/toastError';
import ToastComponent from '../../../common/toastComponent';
import { isNil } from 'lodash';
import apiPath from "../../../../config/apiPaths.json";
import ErrorPopup from '../../../common/ErrorPopup';
import constants from "../../../../config/constants.json";
import { CustomCalendarIconForCalenderNext7Days } from '../../../common/StyledComponents/StyledFields';
import { Box, Typography } from '@mui/material';

const SelectDate = () => {
   const currentDate = new Date();
   const [isOpen, setIsOpen] = useState<boolean>(false);
   const [selectedDate, setSelectedDate] = useState(formatDate(currentDate));
   const [todayScheduleList, setTodayScheduleList] = useState<string[] | []>([
      '09:00 AM  Temple Opens',
      '09:00 AM  Balaji Suprabatam',
      '09:00 AM  Shiva Suprabatam',
      '9:30 AM Nitya Puja for all deities ',
      '09:30 AM  Vishnu Sahasranama Archana',
      '10:00 AM  Starting of Ashtotara Archana schedule',
      '10:30 AM  Starting of Vahana Puja schedule',
      '12:00 PM  Temple Closes for afternoon break',
      '06:00 PM  Temple Opens for Evening services',
      '06:00 PM  Starting of Ashtotara Archana schedule',
      '06:00 PM  Starting of Vahana Puja schedule',
      '07:30 PM  Balaji Ekanta seva',
      '08:00 PM  Temple Closes',
   ]);
   const [isLoading, setIsLoading] = useState<boolean>(false);

   useEffect(() => {
      setIsLoading(true);
      apiRequest({
         method: 'POST',
         endpoint: apiPath.dailyTempleActivity,
         params: {
            scheduleDate: selectedDate,
         }
      })
         .then((res) => {
            setTodayScheduleList(res.data.dailyActivities);
            setIsLoading(false);
         })
         .catch((err) => {
            console.log(err);
            setIsLoading(false);
            toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
               duration: constants.TOAST_POPUP_DURATION,
             });
         });
   }, [selectedDate]);

   function formatDate(date: Date): string {
      const day = date?.getDate();
      const month = date?.getMonth() + 1;
      const year = date?.getFullYear();

      const formattedDay = day < 10 ? `0${day}` : day;
      const formattedMonth = month < 10 ? `0${month}` : month;

      return `${formattedMonth}/${formattedDay}/${year}`;
   }
   const [isCalendarVisible, setIsCalendarVisible] = useState<boolean>(true);
   const handleDateSelection = (date: string) => {
      setSelectedDate(date);
      setIsCalendarVisible(false); // Hide the calendar after date selection
   };

   const calenderDate = () => {
      return (
         <Box
            sx={{
               display: 'flex',
               flexDirection: 'row',
               marginBottom: '10px',
               padding: '10px 0px 0px 0px',
            }}
         >
            {CustomCalendarIconForCalenderNext7Days()}
            <Typography
               sx={{ fontSize: '16px', fontWeight: '600', marginLeft: '8px', fontStyle: 'normal' }}
            >
               {selectedDate} {formatWeekday(new Date(selectedDate))}
            </Typography>
         </Box>
      );
   };


   const render = (): React.ReactElement => {
      return (
         <div className={styles.SelectDateMainContainer}>
            <ToastComponent/>
            {/* {!todayScheduleList.length ? null : <Calendar setSelectedDate={handleDateSelection} />} */}
            {isCalendarVisible && todayScheduleList.length ? <Calendar setSelectedDate={handleDateSelection}/> : null}
            {todayScheduleList.length === 0 && !isLoading ? (
               <div className={styles.NocontentText}>{constants.NO_SHEDULE_AVAILABLE_FOR_SELECTED_DATE}</div>
            ) : (
               <>
               {calenderDate()}
               <ScheduleEventsTemplate itemList={todayScheduleList} />
               </>
               
            )}
         </div>
      );
   };

   return <>{render()}</>;
};

export default SelectDate;
